import { ColumnWithClassname } from "@src/components/modules/Table/tableInterfaces";
import { CSSProperties } from "react";
import { Cell } from "react-table";

/* eslint-disable @typescript-eslint/no-explicit-any */
interface Column {
  Header?: any;
  columns?: Column[];
  getHeaderProps: () => {
    style?: CSSProperties | undefined;
  };
  id: string | number;
  parent?: Column;
  isSticky?: boolean;
  totalLeft: number;
  placeholderOf?: Column;
}

function getStickyValue(column: Column): boolean {
  if (column.isSticky) {
    return column.isSticky;
  }

  if (column.placeholderOf && column.placeholderOf.isSticky) {
    return column.placeholderOf.isSticky;
  }

  if (column.parent) {
    return getStickyValue(column.parent);
  }

  return false;
}

function getStickyZIndexProps(cell: Cell) {
  const isSticky = getStickyValue(cell.column);

  if (!isSticky) {
    return {};
  }

  if ((cell.column as ColumnWithClassname<Record<string, unknown>>).isSticky) {
    return {
      style: {
        whiteSpace: "nowrap",
      },
    };
  }
}

function getStickyProps(header: any) {
  let style = {};
  const dataAttrs = {};

  const sticky = getStickyValue(header);

  if (sticky) {
    style = {
      position: "sticky",
    };

    style = {
      ...style,
      left: `${header.totalLeft}px`,
    };
  }

  return {
    style,
    ...dataAttrs,
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useSticky = (hooks: any): void => {
  hooks.getHeaderProps.push((props: any, { column }: any) => {
    const nextProps = getStickyProps(column);
    return [props, nextProps];
  });

  hooks.getCellProps.push((props: any, { cell }: any) => {
    const nextProps = getStickyProps(cell.column);
    return [props, nextProps];
  });

  hooks.getCellProps.push((props: any, { cell }: any) => {
    const zIndexProps = getStickyZIndexProps(cell);
    return [props, zIndexProps];
  });
};
